import { getFirestore } from "firebase/firestore";
// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAV71SVDGzGshPzoFSW7TMT8eHKgTN4MKA",
  authDomain: "hokiehelper-ed807.firebaseapp.com",
  projectId: "hokiehelper-ed807",
  storageBucket: "hokiehelper-ed807.appspot.com",
  messagingSenderId: "475214205015",
  appId: "1:475214205015:web:873b40423ef3005a1b9312",
  measurementId: "G-7CYZE8K6BH",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
getAnalytics(app);
export const db = getFirestore(app);
